import { render, staticRenderFns } from "./interView.vue?vue&type=template&id=25c4997a"
import script from "./interView.vue?vue&type=script&lang=js"
export * from "./interView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports